export { default } from './ResultTile';